import EngineCleanupBase from '../../services/engines/EngineCleanupBase';
import jxWindowManager from '../JxWindowManager/JxWindowManager.jsx';

const _name = 'JxNoteEngine';
const STORAGE_KEY = 'jx-notes';

/**
 * Persists open Note windows to localStorage — client-only, survives a page refresh.
 * No BE endpoint (see Jerny Source - NoteWidget) — notes live in this browser only.
 * Keyed on window instance id (props.id). On bootup, storage is cleared and every
 * persisted note is re-opened as a fresh window — each new instance re-saves itself
 * under its freshly assigned id (see JxNoteForm.componentDidMount), so ids never drift.
 */
class JxNoteEngine extends EngineCleanupBase {
    bootup = () => {
        try {
            this.initialize(_name);
            this._restore();
        } catch (error) {
            this.logError('bootup', error.message);
        }
    };

    /**
     * @param {string} id - window instance id (props.id)
     * @param {string} body
     */
    save = (id, body) => {
        try {
            const notes = this._readAll();
            notes[id] = body;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(notes));
        } catch (error) {
            this.logError('save', error.message);
        }
    };

    /**
     * @param {string} id
     */
    remove = (id) => {
        try {
            const notes = this._readAll();
            delete notes[id];
            localStorage.setItem(STORAGE_KEY, JSON.stringify(notes));
        } catch (error) {
            this.logError('remove', error.message);
        }
    };

    _readAll = () => {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? {};
        } catch {
            return {};
        }
    };

    _restore = () => {
        const notes = this._readAll();
        localStorage.removeItem(STORAGE_KEY); // cleared now — re-populated by each restored instance's own save()

        Object.values(notes).forEach((body) => {
            jxWindowManager.openWindow('JxNoteForm', 'global', { body }, true);
        });
    };
}

const jxNoteEngine = new JxNoteEngine();
export default jxNoteEngine;
